import { useEffect, useMemo, useState } from "react";

import { Box, createSvgIcon, CssBaseline, ThemeProvider } from "@mui/material";

import { Outlet } from "react-router-dom";
import { ReactComponent as IconLogo } from "../../assets/logosSvg/easyReport.svg";
import { ReactComponent as PerfilReportSvg } from "../../assets/easyReport/iconSvg/perfilReport.svg";
import easyReportTheme from "../../themes/easyReportTheme";
import TopBar from "../../componentes/topBar";
import { Delete, Description, EventNote } from "@mui/icons-material";
import SideBar from "../../componentes/sideBar";
import { Theme } from "@mui/material";
import { ReactNode, Dispatch, SetStateAction } from "react";
import ConfiguracaoEasyReport from "../../componentes/easyReport/configModal";
import Config from "./config";
import api from "../../services/api";

interface LayoutEasyReportProps {
  colorMode: string;
  setColorMode: Dispatch<SetStateAction<string>>;
  socket: unknown;
  socketCliente: unknown;
}

interface RightBarPage {
  itemId: string;
  label: string;
  link: string;
  icon: ReactNode;
}

interface Styles {
  containerLayout: React.CSSProperties;
  containerBody: React.CSSProperties;
  containerOutlet: React.CSSProperties;
}

function LayoutEasyReport(params: LayoutEasyReportProps) {
  const { colorMode, setColorMode, socket, socketCliente } = params;
  const theme = useMemo<Theme>(() => easyReportTheme(colorMode), [colorMode]);
  const [snackbar, setSnackbar] = useState<null | string>(null);
  const [openRightBar, setOpenRightBar] = useState<boolean>(true);
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [openConfig, setOpenConfig] = useState<boolean>(false);
  const [config, setConfig] = useState<EasyReportConfig[]>([]);

  const styles: Styles = {
    containerLayout: {
      display: "flex",
      width: "100%",
      height: "100vh",
      flexDirection: "column",
      overflow: "hidden",
    },
    containerBody: {
      display: "flex",
      width: "100%",
      height: "100%",
      flex: 1,
      minHeight: 0,
    },
    containerOutlet: {
      flex: 1,
      minWidth: 0,
      padding: 3,
      gap: 3,
      overflow: "auto",
    },
  };
  const PerfilReport = createSvgIcon(<PerfilReportSvg />, "PerfilReport");
  const rightBarPages: RightBarPage[] = [
    {
      itemId: "1",
      label: "Relatórios",
      link: "/easyReportV2/relatorios",
      icon: <Description />,
    },
    {
      itemId: "2",
      label: "Agendamento",
      link: "/easyReportV2/agendamento",
      icon: <EventNote />,
    },
    {
      itemId: "3",
      label: "Perfis de Relatório",
      link: "/easyReportV2/perfilRelatorios",
      icon: <PerfilReport />,
    },
    {
      itemId: "4",
      label: "Lixeira",
      link: "/easyReportV2/lixeira",
      icon: <Delete />,
    },
  ];

  async function handleApiGetConfig() {
    try {
      const response = await api.get("/easyReport/v2/findManyConfig");
      if (response.data.status === "Error") {
        setSnackbar("Error: Não foi possível carregar as configurações");
      } else {
        if (response.data) {
          setConfig(response.data);
        }
      }
    } catch (error: any) {
      console.error(error);
      setSnackbar(
        `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
      );
    }
  }

  useEffect(() => {
    handleApiGetConfig();
  }, []);

  return (
    <Box display={"flex"} sx={{ flexDirection: "column", height: "100%" }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box sx={styles.containerLayout}>
          <TopBar
            setOpenDrawer={setOpenDrawer}
            setOpenRightBar={setOpenRightBar}
            iconLogo={<IconLogo />}
            link={"/easyReportV2/relatorios"}
            socket={socket}
            socketCliente={socketCliente}
            colorMode={colorMode}
            setColorMode={setColorMode}
            snackbar={snackbar}
            setSnackbar={setSnackbar}
            tools={<Config setOpenConfig={setOpenConfig} />}
          />
          <Box sx={styles.containerBody}>
            <SideBar
              items={rightBarPages}
              title="Navegação"
              openRightBar={openRightBar}
              setOpenRightBar={setOpenRightBar}
              openDrawer={openDrawer}
              setOpenDrawer={setOpenDrawer}
              iconLogo={<IconLogo />}
            />
            <Box component="main" sx={styles.containerOutlet}>
              <Outlet context={{ config, setConfig }} />
            </Box>
          </Box>
        </Box>
        <ConfiguracaoEasyReport
          open={openConfig}
          setOpen={setOpenConfig}
          config={config}
          setConfig={setConfig}
        />
      </ThemeProvider>
    </Box>
  );
}

export default LayoutEasyReport;
